<div class="kLoginContainer" *ngIf="_showLogin">
  <div class="kLoginCenter">
    <div class="kLoginWindow">
      <div class="kLogo"></div>

      <ng-container [ngSwitch]="_currentScreen">
        <kKMCLoginForm
          *ngSwitchCase="_loginScreens.Login"
          [username]="_username"
          [errorMessage]="_errorMessage"
          [errorCode]="_errorCode"
          [inProgress]="_inProgress"
          [showAuthenticationCode]="_showAuthenticator"
          (onSetScreen)="_setScreen($event)"
          (onRememberMe)="_rememberMe($event)"
          (onLogin)="_login($event)"
        ></kKMCLoginForm>
        <kKMCSsoForm
          *ngSwitchCase="_loginScreens.Sso"
          [username]="_username"
          [errorMessage]="_errorMessage"
          [inProgress]="_inProgress"
          (onRememberMe)="_rememberMe($event)"
          (onSsoLogin)="_ssoLogin($event)"
        ></kKMCSsoForm>
        <kKMCForgotPasswordForm
          *ngSwitchCase="_loginScreens.ForgotPassword"
          [errorMessage]="_errorMessage"
          [inProgress]="_inProgress"
          [passwordReset]="_passwordReset"
          (onResetPassword)="_forgotPassword($event)"
          (onSetScreen)="_setScreen($event)"
        ></kKMCForgotPasswordForm>

        <kKMCPasswordExpiredForm
          *ngSwitchCase="_loginScreens.PasswordExpired"
          [errorMessage]="_errorMessage"
          [errorCode]="_errorCode"
          [inProgress]="_inProgress"
          (onResetPassword)="_resetPassword($event)"
        ></kKMCPasswordExpiredForm>

        <kKMCInvalidLoginHash
          *ngSwitchCase="_loginScreens.InvalidLoginHash"
          [errorMessage]="_errorMessage"
          [inProgress]="_inProgress"
          [passwordReset]="_passwordReset"
          (onResendLink)="_forgotPassword($event)"
          (onSetScreen)="_setScreen($event)"
        ></kKMCInvalidLoginHash>

        <kKMCRestorePassword
          *ngSwitchCase="_loginScreens.RestorePassword"
          [restorePasswordHash]="_restorePasswordHash"
          [inProgress]="_inProgress"
          [errorMessage]="_errorMessage"
          [errorCode]="_errorCode"
          [passwordRestored]="_passwordRestored"
          (returnToLogin)="_returnToLogin()"
          (onRestorePassword)="_restorePassword($event)"
        ></kKMCRestorePassword>
        <kInvalidRetorePasswordHash
          *ngSwitchCase="_loginScreens.RestorePasswordInvalidHash"
          [inProgress]="_inProgress"
          [passwordReset]="_passwordReset"
          [errorMessage]="_errorMessage"
          [errorCode]="_errorCode"
          (returnToLogin)="_setScreen(_loginScreens.Login)"
          (resendRestorePassword)="_forgotPassword($event)"
        ></kInvalidRetorePasswordHash>
        <kKMCAuthentication
          *ngSwitchCase="_loginScreens.Authenticator"
          [hash]="_authenticationHash"
          [qrCode]="_qrCodeBase64"
          (onAuthContinue)="_onAuthContinue()"
        ></kKMCAuthentication>
      </ng-container>
    </div>
    <div class="kLoginControls">
      <ng-container *ngIf="_currentScreen === _loginScreens.Login && _signUpLinkExists">
        <p>{{ 'app.login.dontHaveAccount' | translate }}</p>

        <button class="kSignUpBtn" pButton [label]="'app.login.signUp' | translate" (click)="_signUp()"></button>
      </ng-container>

      <ng-container
        *ngIf="
          _currentScreen !== _loginScreens.Login &&
          _currentScreen !== _loginScreens.Sso &&
          _currentScreen !== _loginScreens.Authenticator
        "
      >
        <button
          class="kSignUpBtn"
          *ngIf="!_qrCodeBase64"
          pButton
          [label]="'app.login.login.title' | translate"
          (click)="_setScreen(_loginScreens.Login)"
        ></button>
        <button
          class="kSignUpBtn"
          pButton
          *ngIf="_signUpLinkExists"
          [label]="'app.login.signUp' | translate"
          (click)="_signUp()"
        ></button>
      </ng-container>

      <ng-container *ngIf="_currentScreen === _loginScreens.Sso">
        <button
          class="kSignUpBtn"
          pButton
          [label]="'app.login.login.loginWithPassword' | translate"
          (click)="_setScreen(_loginScreens.Login)"
        ></button>
      </ng-container>
    </div>
  </div>
</div>

<div class="kBrowserMsgContainer" *ngIf="_showIEMessage">
  <div class="kBrowserMsg">
    <span>{{ 'app.login.login.browserVer1' | translate }}</span
    ><br />
    <span>{{ 'app.login.login.browserVer2' | translate }}</span>
  </div>
</div>
